import { CognitoUserPool } from 'amazon-cognito-identity-js';

// Cognito group required for researcher dashboard access
export const REQUIRED_GROUP = 'hat_data_ui_users';

export const AWS_REGION = 'us-east-1';

// Talk Trees teachers are not 'sagaUser' documents and so have no region to be
// selected by. These pseudo-regions stand in for one in the Data Viewer's region
// selector; each one names the input type its teachers' sessions are stored under.
export const TALK_TREES_REGIONS = {
  'Talk Trees Streams': '2026-talktrees-stream-v1',
  'Talk Trees Uploads': '2026-talktrees-upload-v1',
};

export const TALK_TREES_INPUT_TYPES = Object.values(TALK_TREES_REGIONS);

// Input type to fall back to when a Saga region is selected outside of the
// "Select Client and School Year" dropdown below (e.g. the Data Viewer's
// region picker), so a prior Talk Trees pipeline selection doesn't linger.
export const SAGA_PIPELINE_DEFAULT = '2026-fall-standard';

export const INPUT_TYPE_TO_SCHOOL_YEAR = {
  '2026-talktrees-stream-v1':        'Talk Trees Streams',
  '2026-talktrees-upload-v1':        'Talk Trees Uploads',
  [SAGA_PIPELINE_DEFAULT]:           'Saga 2026-2027',
  '2026-fall-nm-ela':                'Saga NM Literacy 2026-2027',
  '2025-fall-standard':              'Saga 2025-2026',
  // '2024-fall-standard':              'Saga 2024-2025',   // these have been moved to their own database, so not available via API.
  // '2023-fall-standard':              'Saga 2023-2024',   // these have been moved to their own database, so not available via API.
  '2026-spring-teachfx':             'TeachFX 2026 Spring',
  '2025-teachfx-fall-pilot':         'TeachFX 2025 Fall Pilot',
  '2025-teachfx-pilot':              'TeachFX 2025 Spring Pilot',
  '2025-TeachFX-sample':             'TeachFX 2025 ASU-GSV Demo',
  '2025-saga-test':                  'Saga 2025 Testing (Air Tutors)',
  '2025-new-schools-media-standard': 'NewSchools Media Upload Pilot 2025',
};

// Dev account configuration
//
// export const API_BASE_URL = 'https://api.dev.hatproject.org/';
// export const COGNITO_TOKEN_URL = 'https://hat-server-users-dev.auth.us-east-1.amazoncognito.com/oauth2/token';
// const cognitoPoolData = {
//   UserPoolId: 'us-east-1_4bJHVWiv8',
//   ClientId: '7i942tsjok6n1ibtacprn1patj',
// };

// Prod account configuration
//
export const API_BASE_URL = 'https://api.hatproject.org/';
export const COGNITO_TOKEN_URL = 'https://hat-server.auth.us-east-1.amazoncognito.com/oauth2/token';
const cognitoPoolData = {
  UserPoolId: 'us-east-1_JcNQ0Ua6D',
  ClientId: '74k490tr7ua2l114j8nk1fgcc4',
};

export const userpool = new CognitoUserPool(cognitoPoolData);

